import React from "react";
import PropTypes from "prop-types";
import { ArrowDown } from "react-feather";

export default function LogoTableRow(props) {
  return (
    <tr>
      <td className="align-middle p-0">
        {props.logoUrl && (
          <img
            style={{
              minWidth: "250px",
            }}
            src={props.logoUrl}
            alt={props.title}
          />
        )}
      </td>
      <td className="align-middle">
        {props.text && (
          <div className="font-weight-bold pr-3 text-nowrap">{props.text}</div>
        )}
      </td>
      <td className="align-middle">
        <div className="text-nowrap">
          {props.blackSvg && (
            <a
              href={props.blackSvg}
              download
              className="link-icon-group font-weight-bold pr-3 text-nowrap"
              aria-label={`Last ned ${props.title}, svart, svg `}
            >
              <span className="link link-bold">SVG</span>
              <ArrowDown className="ml-1" size="20" strokeWidth="3" />
            </a>
          )}
          {props.blackPng && (
            <a
              href={props.blackPng}
              download
              className="link-icon-group font-weight-bold pr-3 text-nowrap"
              aria-label={`Last ned ${props.title}, svart, png `}
            >
              <span className="link link-bold">PNG</span>
              <ArrowDown className="ml-1" size="20" strokeWidth="3" />
            </a>
          )}
          {props.blackPdf && (
            <a
              href={props.blackPdf}
              download
              className="link-icon-group font-weight-bold pr-3 text-nowrap"
              aria-label={`Last ned ${props.title}, svart, pdf`}
            >
              <span className="link link-bold">PDF</span>
              <ArrowDown className="ml-1" size="20" strokeWidth="3" />
            </a>
          )}
        </div>
      </td>
      <td className="align-middle">
        <div className="text-nowrap">
          {props.whiteSvg && (
            <a
              href={props.whiteSvg}
              download
              className="link-icon-group font-weight-bold pr-3 text-nowrap"
              aria-label={`Last ned ${props.title}, hvit, svg `}
            >
              <span className="link link-bold">SVG</span>
              <ArrowDown className="ml-1" size="20" strokeWidth="3" />
            </a>
          )}
          {props.whitePng && (
            <a
              href={props.whitePng}
              download
              className="link-icon-group font-weight-bold pr-3 text-nowrap"
              aria-label={`Last ned ${props.title}, hvit, png `}
            >
              <span className="link link-bold">PNG</span>
              <ArrowDown className="ml-1" size="20" strokeWidth="3" />
            </a>
          )}
          {props.whitePdf && (
            <a
              href={props.whitePdf}
              download
              className="link-icon-group font-weight-bold pr-3 text-nowrap"
              aria-label={`Last ned ${props.title}, hvit, pdf `}
            >
              <span className="link link-bold">PDF</span>
              <ArrowDown className="ml-1" size="20" strokeWidth="3" />
            </a>
          )}
        </div>
      </td>
    </tr>
  );
}

LogoTableRow.propTypes = {
  logoUrl: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
  blackSvg: PropTypes.string,
  blackPng: PropTypes.string,
  blackPdf: PropTypes.string,
  whiteSvg: PropTypes.string,
  whitePng: PropTypes.string,
  whitePdf: PropTypes.string,
};
